import { getLiteAppPath } from '@components/LocalMerchant/LiteApp/util'
import { PATH_ZGT } from '@components/LocalMerchant/ZhiGuangTong/constant'
import {
  ACCOUNT_SERVICE_PATH,
  ACTIVITY_DIY_PATH,
  COUPONS_PATH,
  JUKE_PATH,
  LIVE_MANAGE_PATH,
  MARKETING_PRODUCT_DETAIL_PATH,
  MULTI_STORE_MANAGE_PATH,
  PRODUCT_ARRIVE_GIFT,
  PRODUCT_CONSULT_GIFT,
  PRODUCT_COUPONS,
  PRODUCT_EASY_CHAT,
  PRODUCT_HAI_CAO_YUN,
  PRODUCT_INVITATION_CARD,
  PRODUCT_JUKE,
  PRODUCT_LIVE,
  PRODUCT_MICRO_WEBSITE,
  PRODUCT_MULTI_SERVICE,
  PRODUCT_MULTI_STORE,
  PRODUCT_REGISTRATION_ACTIVITY,
  PRODUCT_SCHEDULE,
  PRODUCT_SHOP_DATA,
  PRODUCT_SKY_EYE,
  PRODUCT_SMART_RECEPTION,
  PRODUCT_THEME_TEMPLATE,
  PRODUCT_UNIQUE_INFO,
  PRODUCT_VR,
  PRODUCT_WATER_MIRROR,
  PRODUCT_WECHAT_WEAPP,
  PRODUCT_WEDDING_HALL,
  PRODUCT_YOUXUAN,
  PRODUCT_ZHI_GUANG_TONG,
  PRODUCT_ZHI_TUI_BAO,
  PRODUCT_ZHUANXIANG,
  SHOP_DATA_PATH,
  SMART_RECEPTION_PATH,
  WATER_STORE_PATH,
  ZHI_TUI_BAO_PATH
} from '@constant'
import { isSiDaProperty, isUltimate } from '@merchant-backend/util'
import { cantUse, isUltimateOrStandard } from '@util'
import { hashHistory } from 'react-router'
import { getJtiPath, HLJ_STATISTIC } from '../..'

const validateBeforeGo = productId => {
  if (isSiDaProperty()) {
    if (
      productId == PRODUCT_MICRO_WEBSITE ||
      productId == PRODUCT_WECHAT_WEAPP
    ) {
      cantUse()
      return false
    }
  }
  return true
}

/**
 * 营销中心首页所有服务统一跳转
 * 包含埋点
 * TODO, 跳转的旗舰版判断统一到路由配置中处理
 */
export const goMarketingService = (productId, link, statisticKey) => {
  if (statisticKey) {
    HLJ_STATISTIC({
      element_tag: statisticKey,
      page_name: '服务市场/首页'
    })
  }

  const canContinue = validateBeforeGo(productId)
  if (!canContinue) return

  if (link) {
    hashHistory.push(link)
    return
  }

  const _isUltimate = isUltimate()
  const proOrStandard = isUltimateOrStandard()
  const pathMapping = {
    [PRODUCT_ZHI_GUANG_TONG]: PATH_ZGT,
    [PRODUCT_ZHI_TUI_BAO]: ZHI_TUI_BAO_PATH,
    [PRODUCT_LIVE]: `${LIVE_MANAGE_PATH}`,
    [PRODUCT_JUKE]: _isUltimate
      ? JUKE_PATH
      : `${MARKETING_PRODUCT_DETAIL_PATH}/juke`,
    [PRODUCT_REGISTRATION_ACTIVITY]: ACTIVITY_DIY_PATH,
    [PRODUCT_WECHAT_WEAPP]: getLiteAppPath(),
    [PRODUCT_MICRO_WEBSITE]: '/localMerchant/weiShopSetting',
    [PRODUCT_WEDDING_HALL]: `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_WEDDING_HALL}`, // 婚礼现场
    [PRODUCT_COUPONS]: proOrStandard
      ? COUPONS_PATH
      : `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_COUPONS}`, // 优惠券
    [PRODUCT_CONSULT_GIFT]: proOrStandard
      ? '/localMerchant/marketingTools?key=32'
      : `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_CONSULT_GIFT}`,
    [PRODUCT_ARRIVE_GIFT]: proOrStandard
      ? '/localMerchant/marketingTools'
      : `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_ARRIVE_GIFT}`,
    [PRODUCT_MULTI_STORE]: _isUltimate
      ? MULTI_STORE_MANAGE_PATH
      : `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_MULTI_STORE}`,
    [PRODUCT_MULTI_SERVICE]: isUltimateOrStandard()
      ? ACCOUNT_SERVICE_PATH
      : `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_MULTI_SERVICE}`,
    [PRODUCT_SMART_RECEPTION]: SMART_RECEPTION_PATH,
    [PRODUCT_WATER_MIRROR]: getJtiPath(WATER_STORE_PATH),
    [PRODUCT_HAI_CAO_YUN]: `${MARKETING_PRODUCT_DETAIL_PATH}/haicaoyun`,
    [PRODUCT_INVITATION_CARD]: `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_INVITATION_CARD}`,
    [PRODUCT_SHOP_DATA]: proOrStandard
      ? SHOP_DATA_PATH
      : `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_SHOP_DATA}`,
    [PRODUCT_THEME_TEMPLATE]: '/localMerchant/themeChose',
    [PRODUCT_UNIQUE_INFO]: '/localMerchant/uniqueInfo',
    [PRODUCT_ZHUANXIANG]: '/localMerchant/exclusiveOffers',
    [PRODUCT_YOUXUAN]: `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_YOUXUAN}`,
    [PRODUCT_EASY_CHAT]: '/localMerchant/easyChat',
    [PRODUCT_VR]: '/localMerchant/vr',
    [PRODUCT_SKY_EYE]: `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_SKY_EYE}`,
    [PRODUCT_SCHEDULE]: '/localMerchant/scheduleTool'
    // [PRODUCT_NAME_CARD]: _isUltimate
    //   ? NAME_CARD_MANAGE_PATH
    //   : `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_NAME_CARD}` // 海草名片
  }

  const path = pathMapping[String(productId)]

  if (
    productId == PRODUCT_SMART_RECEPTION ||
    productId == PRODUCT_WATER_MIRROR
  ) {
    path && window.open(path)
  } else {
    path && hashHistory.push(path)
  }
}

/**
 * 营销中心首页V2所有服务统一跳转
 * 包含埋点
 * TODO, 跳转的旗舰版判断统一到路由配置中处理
 */

export const goMarketingServiceV2 = (link, statisticKey) => {
  if (statisticKey) {
    HLJ_STATISTIC({
      element_tag: statisticKey,
      page_name: '服务市场/首页'
    })
  }
  if (link.indexOf('/p/wedding/') > -1) {
    window.open(link)
  } else {
    hashHistory.push(link)
  }

  return
}
